export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7246.9feef85e.jpg";